import React from 'react'
import { useTranslation } from 'react-i18next'

import { Label } from '../../../../../../../components/presentation/Text'
import { useChecklistFormActions, useSelectedQuestion } from '../../../../_form/ChecklistFormHandler'
import Button from '../../../../../../../components/actions/Button'
import FlexGrid from '../../../../../../../components/structure/FlexGrid'
import Modal from '../../../../../../../components/structure/Modal'
import Separator from '../../../../../../../components/helpers/Separator'
import Textarea from '../../../../../../../components/form/Textarea'

const ExpandableQuestionModal = ({ open, onClose, field, label }) => {
  const { t } = useTranslation('common')
  const selectedQuestion = useSelectedQuestion()
  const { handleSelectedQuestionChange } = useChecklistFormActions()

  return (
    <Modal open={open} onClose={onClose} width="42rem">
      <Label>{label}</Label>
      <Textarea
        limit={255}
        rows={8}
        value={selectedQuestion[field]}
        onStopTyping={handleSelectedQuestionChange(field)}
      />

      <Separator weight={6} />

      <FlexGrid justify="flex-end">
        <Button onClick={onClose}>{t('save')}</Button>
      </FlexGrid>
    </Modal>
  )
}

export default ExpandableQuestionModal
